export const Errors = {
  BAD_REQUEST: 400,
  PESEL_ALREADY_EXISTS: 409,
};
